import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    cardWrapper: {
        
    },
    cardLink: {
        '&, &:hover': {
            textDecoration: 'none',
        }
    },
    cardDisabled: {
        cursor: 'none',
        pointerEvents: 'none',
    },
    cardContentWrapper: {},
    cardContent: {
        position: 'relative',
        padding: theme.spacing(2,2,2,8),
    },
    iconWrapper: {
        position: 'absolute',
        left: theme.spacing(2),
    },
    icon: {
        width: 32,
    },
    cardName: {
        fontSize: 20,
        fontWeight: 500,
    },
    cardLabel: {
        fontSize: 12,
        color: 'rgba(152,152,152,1)',
        marginTop: theme.spacing(1.25),
    },
    cardValue: {
        fontSize: 15,
        color: 'rgba(14,14,14,1)',
    },
    cardValueSmall: {
        fontSize: 12,
        color: 'rgba(152,152,152,1)',
    },

}));
